import { render } from "./ManageAudioVariantModal.vue?vue&type=template&id=65cacf1e&scoped=true"
import script from "./ManageAudioVariantModal.vue?vue&type=script&lang=js"
export * from "./ManageAudioVariantModal.vue?vue&type=script&lang=js"

import "./ManageAudioVariantModal.vue?vue&type=style&index=0&id=65cacf1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cacf1e"]])

export default __exports__